import { TableCell, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import HoursInput from '../../components/HoursInput';
import { hourFields } from '../../config/staticValues';
import { useCallback } from 'react';
import { debounce } from '../../redux/hooks/use-debounce';
import { saveWorkday } from '../../redux/timecard';
import { useDispatch, useSelector } from 'react-redux';
import dateUtil from '../../util/dateUtil';
import Visible from '../../components/Visible';

const TimecardDatasheetDay = ({ row, disabled, classes, saveUpdate }) => {
  const dispatch = useDispatch();
  const timecard = useSelector((state) => state.timecard);
  const setValue = (id, value) => {
    const dayToUpdate = saveUpdate(row, id, value);
    if (value != undefined) updateServer(dayToUpdate);
  };
  const updateServer = useCallback(
    debounce((data) => {
      dispatch(saveWorkday(data));
    }, 2000),
    [timecard]
  );
  return (
    <TableRow>
      <TableCell component="th" scope="row" align="right" className={classes.dayColumn}>
        <Visible smUp>
          <Typography className={classes.dayText}>
            {dateUtil.stringToDateFormat(row.workDate, 'EEEE LLLL do')}
          </Typography>
        </Visible>
        <Visible xsDown>
          <Typography>{dateUtil.stringToDateFormat(row.workDate, 'EEE L/d')}</Typography>
        </Visible>
      </TableCell>
      {hourFields.map((field, index) => (
        <TableCell key={index}>
          <HoursInput
            limitHours={true}
            setValue={(value) => setValue(field.id, value)}
            value={row[field.id]}
            disabled={disabled}
          />
        </TableCell>
      ))}
      <Visible mdUp>
        <TableCell align="right">
          <Typography>{Number.parseFloat(row.clockedHours).toFixed(2)}</Typography>
        </TableCell>
        <TableCell align="right">
          <Typography> {Number.parseFloat(row.serviceHours).toFixed(2)}</Typography>
        </TableCell>
        <TableCell align="right">
          <Typography>
            {(
              Number.parseFloat(row.bonusHours) + Number.parseFloat(row.bonusHoursOver38)
            ).toFixed(2)}
          </Typography>
        </TableCell>
      </Visible>
    </TableRow>
  );
};

export default TimecardDatasheetDay;
